module.exports = __webpack_public_path__ + "static/media/downArrow.11038258.svg";